import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
// Copyright IBM Corp. 2022
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React, { useState } from 'react';
import { Button, ButtonSet, Dropdown, Search, Tag } from 'carbon-components-react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Filter16 } from '@carbon/icons-react';
import { pkg } from '../../settings';
var blockClass = "".concat(pkg.prefix, "--add-select__global-filter");
var componentName = 'AddSelectFilter';
export var AddSelectFilter = function AddSelectFilter(_ref) {
  var appliedFilters = _ref.appliedFilters,
      clearFiltersText = _ref.clearFiltersText,
      filterOpts = _ref.filterOpts,
      handleFilter = _ref.handleFilter,
      handleSearch = _ref.handleSearch,
      hasFiltersApplied = _ref.hasFiltersApplied,
      iconDescription = _ref.iconDescription,
      inputLabel = _ref.inputLabel,
      inputPlaceholder = _ref.inputPlaceholder,
      multi = _ref.multi,
      placeholder = _ref.placeholder,
      primaryButtonText = _ref.primaryButtonText,
      searchTerm = _ref.searchTerm,
      secondaryButtonText = _ref.secondaryButtonText;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var searchHandler = function searchHandler(e) {
    handleSearch(e.target.value);
  };

  var onchangeHandler = function onchangeHandler(_ref2, id) {
    var selectedItem = _ref2.selectedItem;
    setFilters(_objectSpread(_objectSpread({}, filters), {}, _defineProperty({}, id, selectedItem)));
  };
  /**
   * this component needs to manage it's own internal state of filters before they're applied
   * setFilters manages the local filter state
   * applyFilters adds the filter state to the parent
   * resetFilters resets the local state
   * clearFilters resets both
   */


  var applyFilters = function applyFilters() {
    setOpen(false);
    handleFilter(filters);
  };

  var resetFilters = function resetFilters() {
    setFilters({});
  };

  var clearFilters = function clearFilters() {
    resetFilters();
    handleFilter({});
  };

  var removeTag = function removeTag(key) {
    var newFilters = _objectSpread({}, filters);

    delete newFilters[key];
    setFilters(newFilters);
    handleFilter(newFilters);
  };

  var getSelectedItem = function getSelectedItem(id) {
    return filters[id] || '';
  };

  var showFilter = multi && (filterOpts === null || filterOpts === void 0 ? void 0 : filterOpts.length) > 0;
  var filterBtnClassnames = cx("".concat(blockClass, "-toggle"), _defineProperty({}, "".concat(blockClass, "-toggle--open"), open));
  var dirtyInput = Object.keys(filters).length > 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-search")
  }, /*#__PURE__*/React.createElement(Search, {
    id: "temp-id",
    labelText: inputLabel,
    placeholder: inputPlaceholder,
    value: searchTerm,
    onChange: searchHandler
  }), showFilter && /*#__PURE__*/React.createElement(Button, {
    renderIcon: Filter16,
    hasIconOnly: true,
    kind: "ghost",
    onClick: function onClick() {
      return setOpen(!open);
    },
    iconDescription: iconDescription,
    className: filterBtnClassnames,
    size: "lg",
    tooltipPosition: "left"
  }), open && /*#__PURE__*/React.createElement("div", {
    className: blockClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-content")
  }, /*#__PURE__*/React.createElement("p", null, "Filters"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-opts")
  }, filterOpts.map(function (filterOpts) {
    return /*#__PURE__*/React.createElement(Dropdown, {
      id: filterOpts.id,
      key: filterOpts.id,
      titleText: filterOpts.label,
      items: filterOpts.opts,
      light: true,
      onChange: function onChange(value) {
        return onchangeHandler(value, filterOpts.id);
      },
      selectedItem: getSelectedItem(filterOpts.id),
      label: placeholder
    });
  }))), /*#__PURE__*/React.createElement(ButtonSet, {
    className: "".concat(blockClass, "-button-set")
  }, /*#__PURE__*/React.createElement(Button, {
    kind: "secondary",
    onClick: resetFilters,
    className: "".concat(blockClass, "-button"),
    disabled: !dirtyInput
  }, secondaryButtonText), /*#__PURE__*/React.createElement(Button, {
    kind: "primary",
    onClick: applyFilters,
    className: "".concat(blockClass, "-button"),
    disabled: !dirtyInput && !hasFiltersApplied
  }, primaryButtonText)))), hasFiltersApplied && /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-applied")
  }, Object.keys(appliedFilters).map(function (filterType) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: filterType,
      type: "gray",
      size: "sm",
      onClose: function onClose() {
        return removeTag(filterType);
      },
      filter: true
    }, "".concat(filterType, ": ").concat(appliedFilters[filterType]));
  }), /*#__PURE__*/React.createElement(Button, {
    kind: "ghost",
    size: "sm",
    onClick: clearFilters
  }, clearFiltersText)));
};
AddSelectFilter.propTypes = {
  appliedFilters: PropTypes.object,
  clearFiltersText: PropTypes.string,
  filterOpts: PropTypes.array,
  handleFilter: PropTypes.func,
  handleSearch: PropTypes.func,
  hasFiltersApplied: PropTypes.bool,
  iconDescription: PropTypes.string,
  inputLabel: PropTypes.string.isRequired,
  inputPlaceholder: PropTypes.string,
  multi: PropTypes.bool,
  placeholder: PropTypes.string,
  primaryButtonText: PropTypes.string,
  searchTerm: PropTypes.string,
  secondaryButtonText: PropTypes.string
};
AddSelectFilter.displayName = componentName;